"use client"
import React from "react"
import TempMessage from "../../../../../components/TempMessage/TempMessage";
import { BsStar } from "react-icons/bs";
import { BsStarFill } from "react-icons/bs";
import { BsThreeDotsVertical } from "react-icons/bs";
import { ImShare } from "react-icons/im";
import { VscMultipleWindows } from "react-icons/vsc";
import { FaRegEdit } from "react-icons/fa";
import {useTekstClient} from "../../../../../hooks/useTekstClient";
import useGebruiker from "../../../../../hooks/useGebruiker";
import {useShareUrl} from "../../Hooks/useShareUrl";
import Dropdown from "react-bootstrap/Dropdown"
import {useFormTitle} from "../../../../../hooks/useFormTitle";
const ContentListItemRight = ({item, handleBookmark, handleOpenInNieuwVenter, handleBewerken, CustomToggle}) => {
    const {tekst} = useTekstClient()
    const {ingelogdeGebruiker} = useGebruiker()
    const [showKopieMsg,  handleDelen] = useShareUrl(false)
    const {formTitle} = useFormTitle()

    return (
        <div className={`flex items-center gap-2`}>
            {/*Bookmark*/}
            {ingelogdeGebruiker && (item.bookmarked ?
                <BsStarFill className={`text-kleur-geel cursor-pointer`}
                            onClick={() => handleBookmark(item.id)}
                            title={tekst('pagina:support:kenniscentrum:lijst-item:favoriet:titel')}
                ></BsStarFill>
                :
                <BsStar
                    className={`` + (ingelogdeGebruiker ? 'cursor-pointer' : ' ' + ``)}
                    onClick={() => ingelogdeGebruiker && handleBookmark(item.id)}
                    title={!ingelogdeGebruiker && tekst('pagina:support:kenniscentrum:lijst-item:favoriet:inlogvereist')}
                />)
            }

            {/*DropdownOptions*/}
            <Dropdown className={`relative`}>
                <TempMessage
                    variant={'info'}
                    message={'De link is gekopieerd'}
                    show={showKopieMsg}
                />
                <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                    <BsThreeDotsVertical/>
                </Dropdown.Toggle>
                <Dropdown.Menu className={``}>
                    <Dropdown.Item className={`flex items-center gap-1`} eventKey="1" onClick={() => {
                        handleDelen(`${window.location.href.split('?')[0]}/id/${item.id}/${formTitle(item.content_gepubliceerd?.titel)}`)
                    }}><ImShare/>{tekst('pagina:support:kenniscentrum:lijst-item:menu:delen')}
                    </Dropdown.Item>
                    <Dropdown.Item className={`flex items-center gap-1`} eventKey="2"
                                   onClick={() => handleOpenInNieuwVenter(item)}><VscMultipleWindows/>{tekst('pagina:support:kenniscentrum:lijst-item:menu:Open in nieuw venter')}
                    </Dropdown.Item>
                    {ingelogdeGebruiker && item.ingelogdeGebruikerMagSchrijven === 1
                        && <Dropdown.Item className={`flex items-center gap-1`} eventKey="3"
                                          onClick={handleBewerken}><FaRegEdit/>{tekst('algemeen:Bewerken')}
                        </Dropdown.Item>
                    }
                </Dropdown.Menu>
            </Dropdown>
        </div>
    )
}

export default ContentListItemRight
